export default __webpack_public_path__ + "static/media/ex-product.ab2617a7.jpg";